<div
  class="flex flex-row items-center"
  [ngClass]="navPlacement === 'overlay' ? 'relative' : ''"
>
  <button
    type="button"
    *ngIf="photos.length > 1"
    class="flex flex-shrink-0 cursor-pointer items-center border-none bg-transparent px-1 py-0 leading-none text-gray-500 hover:text-gray-700"
    [ngClass]="navPlacement === 'overlay' ? 'absolute left-0 z-10' : ''"
    (click)="slider?.prev()"
    aria-label="Previous photo"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div class="flex min-w-0 flex-1 flex-col overflow-hidden">
    <div class="keen-slider" #sliderRef>
      <div class="keen-slider__slide relative" *ngFor="let photo of photos">
        <button
          type="button"
          class="tl-photo-slide block w-full cursor-pointer border-none bg-transparent p-0 aspect-video"
          (click)="photoClick.emit(photo)"
        >
          <img
            [src]="srcFor(photo)"
            loading="lazy"
            alt=""
            class="h-full w-full object-cover object-center"
          />
        </button>
        <div
          *ngIf="showPrimaryBadge && photo.isPrimary"
          class="absolute bottom-0 right-0 rounded-tl-lg bg-white/90 px-1.5 py-0.5 text-xs text-theme-black"
        >
          Primary Photo
        </div>
      </div>
    </div>

    <div
      *ngIf="photos.length > 1"
      class="text-center text-xs text-gray-500"
      [ngClass]="
        navPlacement === 'overlay'
          ? 'absolute bottom-1.5 left-1/2 z-10 -translate-x-1/2 rounded-full bg-white/90 px-2 py-0.5'
          : 'py-1'
      "
    >
      {{ currentSlide + 1 }} / {{ photos.length }}
    </div>
  </div>

  <button
    type="button"
    *ngIf="photos.length > 1"
    class="flex flex-shrink-0 cursor-pointer items-center border-none bg-transparent px-1 py-0 leading-none text-gray-500 hover:text-gray-700"
    [ngClass]="navPlacement === 'overlay' ? 'absolute right-0 z-10' : ''"
    (click)="slider?.next()"
    aria-label="Next photo"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
